interface MetaAtingidaBadgeProps {
  value: number;
}

const MetaAtingidaBadge = ({ value }: MetaAtingidaBadgeProps) => {
  const getColorClass = (percentage: number) => {
    if (percentage >= 90)
      return "bg-success-light text-success-text border-success-light";
    if (percentage >= 70)
      return "bg-info-light text-info-text border-info-light";
    if (percentage >= 50)
      return "bg-warning-light text-warning-text border-warning-light";
    return "bg-error-light text-error-text border-error-light";
  };

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-1 text-xs font-medium ${getColorClass(
        value
      )}`}
    >
      {value.toFixed(1)}%
    </span>
  );
};

export default MetaAtingidaBadge;
